# out: $1.js, compress: false, sourcemap: true
module = ->
  $ ->
    # Кнопка вверх
    $up = $("#up")
    # Таймер отключения кнопки вверх
    upTimerId = -1

    $up.click ()->
      $(window).scrollTop(0)

    $(window).scroll ->
        if upTimerId != -1
          clearTimeout(upTimerId)
        if $(window).scrollTop() > 250
          $up.show()
          mobile = window.matchMedia("(max-width: 980px)");
          if mobile.matches
            upTimerId = setTimeout ()->
              $up.hide()
            , 3000
        else
          $up.hide()

    # Версия для слабовидящих
    $("[name=site-version]").on 'change', ()->
      siteVersion =  $("[name=site-version]:checked").val()
      Cookies.set('site_version', siteVersion)
      $("body").attr('site-version', siteVersion)
      if siteVersion == "n" && window.mainSlider
        window.mainSlider.slick('slickGoTo', 0, true)

    # Валидация ввода дат
    $(".datepicker-here").on "keypress", (e)->
      if (e.charCode < 48 || e.charCode > 57) && e.charCode != 45 && e.charCode != 32 && e.charCode != 46
        e.preventDefault()

    $(".datepicker-here").on "keyup, change", (e)->
      value = $(this).val()
      console.log(value)
      if !value.match(/^(\s*)(\d{1,2})\.(\d{1,2})\.(\d{4})(\s*)$/) && !value.match(/^(\s*)(\d{1,2})\.(\d{1,2})\.(\d{4})(\s*)-(\s*)(\d{1,2})\.(\d{1,2})\.(\d{4})(\s*)$/)
        $(this).val("")
        e.preventDefault()


    if Cookies.get("user_city")?
      $(".user-city select").val(Cookies.get("user_city"))

  # Установка нового города.
    $(".user-city select").on 'change', (event)->
      Cookies.set("user_city", $(".user-city select").val())
      page.applyCity()


  # Обработка подписки.
  $(".apply-subscription").click (event)->

    subscriptionForm = $(this).parents("form")
    subscriptionContent = subscriptionForm.find(".http-content")



    showError = (err)->
      subscriptionContent
        .prepend("<span class='http-error'>#{err}</span>")



    subscriptionContent.find(".http-error").remove()
    email = subscriptionForm.find("[name=email]").val()
    if email.length == 0
        subscriptionForm.find("[name=email]")
        showError("Не указан e-mail")
        return
    if !(email.match window.emailPattern)
        showError("Указан не корректный e-mail")
        return
    rubrics = subscriptionForm.find("[name=rubric]:checked");
    if rubrics.length == 0
        showError("Не выбрана ни одна рубрика")
        return

    $.ajax subscriptionForm.attr("action"), {
      data: subscriptionForm.serialize()
    }
    .done (html)->
      subscriptionContent.html($.parseHTML(html))
      subscriptionContent.nextAll().remove()

      window.location.reload()  if window.location.pathname.indexOf("subscribe-page") != -1

      return
    .fail (object)->
      subscriptionContent.prepend($.parseHTML(object.responseText).find(".content-wrap").html())
      return
    .always ()->
      return


    event.preventDefault()


  container = $(".page-left-additional-image-link-wrap")
  if window.bannerSource?
    container = $(".page-left-additional-image-link")

    $.get("/getBannerJson?rcode=#{bannerSource}")
      .done (json)->
        json = $.parseJSON(json)
        if json.article_title?
          template = """
            <style>
              #ab#{json.article_id}{
                  background:url(/getimage?id=#{json.article_id}&mw=219&mh=300&crop=1)
              }
            </style>
            <p class="page-left-additional-image-link-title">#{json.article_title || ''}</p>
            <p class="page-left-additional-image-link-desc">#{json.article_content || ''}</p>
            <a href="/#{bannerSource}/#{json.article_id || ''}" class="g-button">Подробнее</a>
          """
          container.attr("id","ab#{json.article_id}")
          container.html($.parseHTML(template))
          container.show(500)
  else if container.length > 0
    container.hide()



  reload = (skip, $link)->
    url = window.location
    if $link && $link.attr('href') && $link.attr('href').length > 0
      url = $link.attr('href')
    if $("[name=y]").length != 0
      url = "/"+$("[name=y]").attr("section")+"?1=1";
      if skip?
        url += "&skip=#{skip}"
    if ($("[name=y]").length != 0 && $("[name=y]:checked").val() && $("[name=y]:checked").val().length != 0)
      url += "&y="+$("[name=y]:checked").val()
      if ($("[name=m]:checked").length != 0 && $("[name=m]:checked").val().length != 0)
        url += "&m="+$("[name=m]:checked").val()

    $.get(url).done (html)->
      $html =  $($.parseHTML(html))
      $pagination =$html.find(".pagenation")
      if $pagination? && $pagination.length > 0
        if ($(".pagenation").length == 0)
          $(".page-content").append("<div class='pagenation'></div>")
        $(".pagenation").replaceWith($pagination)
      else
        $(".pagenation").remove()
      $(".news-list").not(".no-replace").replaceWith(
        $html.find(".news-list").not(".no-replace")
      )
      $(".page-ajax-content").not(".no-replace").replaceWith(
        $html.find(".page-ajax-content").not(".no-replace")
      )
      ###
        Если ссылке не установле атрибут disable-auto-scroll или данный атрибут
        установлен в 0, то автоматически скроллим к элементу с классом page-content
      ###
      disableScroll = $link?.attr('disable-auto-scroll')
      if !disableScroll || disableScroll == "0"
        elementOnTop = $(".page-content")
        if (elementOnTop.length > 0)
          $("html, body").animate {
            scrollTop: elementOnTop.offset().top - $("header").height()
          }, 300

        # if ($(".page-ajax-content").not(".no-replace").length > 0)
        #   $('html, body').animate({
        #       scrollTop: $(".page-ajax-content").not(".no-replace").offset().top - $("header").height()
        #   }, 300)
        #
        # if ( $(".news-list").not(".no-replace").length > 0)
        #   $('html, body').animate({
        #       scrollTop: $(".news-list").not(".no-replace").offset().top - $("header").height()
        #   }, 300)

      $(".page-right-title-news-wrap *[skip], .page-ajax-content ~ .pagenation *[skip]").click (e)->
        reload($(this).attr("skip"), $(this))
        e.preventDefault()

  loadMonths = (monthSelector, section)->
    $.ajax({
      type: "POST",
      url: "jsonArticleMonth?r="+section+"&y="+$("[name=y]:checked").val(),
      dataType: "text",
      contentType: "text/xml",
      success: ( data, textStatus, jqXHR )->
        json = $.parseJSON(data)
        monthSelector.html("")
        monthSelector.append("<label class='all'><input  disable-auto-scroll='1'  type='radio' name='m' value='' checked='checked'/><span>Все месяцы</span></label>")
        checked = ''
        checked = 'checked="checked"' if json.length == 1
        for month in json
          monthSelector.append("<label><input  disable-auto-scroll='1'  #{checked} type='radio' name='m' value='#{month.month_number}'><span>#{month.article_date_month}</span></label>")
        monthSelector.show()

        monthSelector.find("[name=m]").change ()->
          reload(undefined, $(this))
          return
        return
    })
    return

  yearChanged = (_this)->
    monthSelector = $(".month")
    monthSelector.unbind("change")
    if ($("[name=y]:checked").val() && $("[name=y]:checked").val().length > 0)
      if (monthSelector.length > 0)
        monthSelector.html()
        monthSelector.append("<label class='all'><input  disable-auto-scroll='1' type='radio' name='m' value='' checked='checked'/><span>Все месяцы</span></label>")
        loadMonths(monthSelector, $("[name=y]").attr("section"))
    else
      if monthSelector.length > 0
        monthSelector.find("[name=m]:checked").prop( "checked", false );
        monthSelector.html()
        monthSelector.hide()

    reload(undefined, $(_this))
  $ ->
    window.page.addCityChangeHandler (cityCode)->
      press_center = $(".press_center")
      if press_center.length > 0
        $(".site-logo a img").attr("src", logoBase.replace('{citycode}', cityCode))

        if press_center.length > 0
          $.get("articles_block?usercity=#{cityCode}&index_0=news&embed=true&lang=ru")
          .done (html)->
            press_center.replaceWith($.parseHTML(html))
      else
        # window.location.reload()

    if ($("[name=y]").length > 0)
      $("[name=m]").parent().show() if ($("[name=y]:checked").val() && $("[name=y]:checked").val().length != 0)

      $("[name=y]").change ()->
        yearChanged($(this))
        return

    $(".page-right-title-news-wrap *[skip], .page-ajax-content ~ .pagenation  *[skip]").click (e)->
      reload($(this).attr("skip"), $(this))
      e.preventDefault()
    $(".spoiler-title").click (e)->
      $($(this).parent()).find(" > .spoiler-content").toggle(200)
      $($(this).parent()).toggleClass('is-open')
      e.preventDefault()

    # GITS#46546 2. При нажатии по основному меню оно должно сворачиваться и разворачиваться. Сейчас только разворачивается(мобилка)
    $(".first_li.current > a").unbind  "click"
    $(".first_li.current > a").click (e)->

      mq = window.matchMedia( "screen and (max-width: 980px)" )
      if mq.matches
        e.preventDefault()
        $(".first_li.current .second_menu").toggle()

    # GITS#46846
    ###
    $("a.file").each ()->
      CommonRequest.fileInfo this, (info)=>
        $(this).html("<span class='file-nickname'>#{$(this).text()}</span><span class='file-info'>(#{info.format.toUpperCase()}, #{info.size} #{info.sizeUnits})</span>")
        ###

    exts = ['doc','docx','rtf','xls','xlsx','ppt','pdf','rar','zip']
    # GITS#47079
    target = $("a:not([id^='banner'])").filter ()->
      ref = $(this).attr('href')
      return false if !ref
      ext3 = ref.toLowerCase().substr(ref.length-3, 3)
      ext4 = ref.toLowerCase().substr(ref.length-4, 4)
      return ref.indexOf('.') != -1 && (exts.indexOf(ext3) != -1 || exts.indexOf(ext4) != -1)

    target.each ()->
      $(this).attr('site-file',$(this).attr('href').toLowerCase)
      CommonRequest.fileInfo this, (info)=>
        $(this).html("<span class='file-nickname'>#{$(this).text()}</span><span class='file-info'>(#{info.format.toUpperCase()}, #{info.size} #{info.sizeUnits})</span>")

unit.define "site::global", module, "site::all_pages", "site::tools", "site::adaptive-tables", "site::page", "site::map-link"
